import { BranchesNearYouPageQueryDocument, BranchesNearYouPageQueryQuery } from '@medprev-web-app/api-graphql-client';

import { ApolloClient } from '@/graphql/apollo-client';

export async function getBranchesNearYou(city: string, state: string): Promise<BranchesNearYouPageQueryQuery | undefined> {
  const { data } = await ApolloClient.query({
    query: BranchesNearYouPageQueryDocument,
    variables: { city, state },
  });

  return data!;
}
